import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {opacity: 0;}
  to {opacity: 1;}
`;

export const Item = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  position: relative;
  z-index: 3;
  pointer-events: none;
  animation: ${fadeIn} 0.5s;
  font-style: ${({ $chatType }) =>
    $chatType === 'user' ? 'italic' : 'default'};
  * {
    pointer-events: auto;
  }
  a {
    color: ${(props) => props.theme.color.secondary};
  }
`;

export const ChatBubbleWrapper = styled.div`
  pointer-events: none;
  position: relative;
`;

export const ChatNameWrapper = styled.div`
  margin-bottom: 0.5rem;
  max-width: 8rem;
  line-height: 1rem;
`;

export const IsAIIconWrapper = styled.div`
  position: absolute;
  top: -6px;
  left: -2px;
  cursor: help;
  z-index: 1;
  text-shadow: 1px 1px ${({ theme }) => theme.color.secondaryDark};
`;
